var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jds-flex jds-mt-4 jds-ml-2"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }